import appUtils from '@/utils/appUtils'
import axios from 'axios'

const pendingRequests = new Map()

function getRequestKey (config) {
  return `${config.method}-${config.url}-${JSON.stringify(config.params)}-${JSON.stringify(config.data)}`
}

const axiosInstance = axios.create({
  baseURL: `${process.env.VUE_APP_BASE_API}api/`
  // timeout: 300000
})

axiosInstance.defaults.timeout = 5 * 60 * 1000 // 60 seconds

axiosInstance.interceptors.request.use(
  (config) => {
    const requestKey = getRequestKey(config)
    // if (pendingRequests.has(requestKey)) {
    //   const cancelToken = pendingRequests.get(requestKey)
    //   cancelToken.cancel('Request canceled due to duplicate request.')
    //   pendingRequests.delete(requestKey)
    // }

    const token = appUtils.getLocalToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }

    const source = axios.CancelToken.source()
    config.cancelToken = source.token
    pendingRequests.set(requestKey, source)

    return config
  },
  (error) => {
    if (axios.isCancel(error)) {
      console.warn('Request canceled:', error.message)
    }

    if (error.configs) {
      const requestKey = getRequestKey(error.configs)
      pendingRequests.delete(requestKey)
    }
    return Promise.reject(error)
  }
)

axiosInstance.CancelToken = axios.CancelToken
axiosInstance.isCancel = axios.isCancel
axiosInstance.cancelAll = () => {
  for (const cancel of pendingRequests.values()) cancel('Request canceled all')
  pendingRequests.clear()
}

// axiosInstance.interceptors.response.use(
//   (res) => {
//     return res;
//   },
//   async (err) => {
//     const originalConfig = err.config;

//     if (originalConfig.url !== "/login" && err.response) {
//       // Access Token was expired
//       if (err.response.status === 401 && !originalConfig._retry) {
//         originalConfig._retry = true;

//         try {
//           const rs = await axiosInstance.post("/auth/refreshtoken", {
//             refreshToken: appUtils.getLocalRefreshToken(),
//           });

//           const { accessToken } = rs.data;

//           // store.dispatch("auth/refreshToken", accessToken);
//           appUtils.updateLocalAccessToken(accessToken);

//           return axiosInstance(originalConfig);
//         } catch (_error) {
//           return Promise.reject(_error);
//         }
//       }
//     }

//     return Promise.reject(err);
//   }
// );

export default axiosInstance
